import Fetch from '@/services/fetch/Fetch';
import { envToBaseUrl } from '@/utils/env';
import { ReactNode, createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useEnv } from './env-provider';
import { UserType } from '@/shared-types/roleTypes';

const initialState: UserType = {
  email: '',
  role: 'viewer',
  restrictions: {},
  editConfigEnabled: false,
};

const UserProviderContext = createContext<UserType>(initialState);

export function UserProvider({ children }: { children: ReactNode }) {
  const { env } = useEnv();

  const endpoint = `${envToBaseUrl(env)}/roles/lookup`;

  const { data } = useQuery<UserType>({
    queryKey: [endpoint, { env }],
    queryFn: () => Fetch.json(endpoint),
    refetchOnWindowFocus: false,
  });

  let editConfigEnabled = false;
  const marketRestricted = data?.restrictions?.markets === undefined;
  if (env === 'cte') {
    editConfigEnabled =
      (data?.role === 'editor' && marketRestricted) ||
      (data?.role === 'creator' && marketRestricted) ||
      data?.role === 'admin';
  } else {
    editConfigEnabled = data?.role === 'admin';
  }

  return (
    <UserProviderContext.Provider
      value={
        data
          ? { ...data, editConfigEnabled }
          : { ...initialState, editConfigEnabled }
      }
    >
      {children}
    </UserProviderContext.Provider>
  );
}

export const useUser = () => {
  const context = useContext(UserProviderContext);

  if (!context) {
    throw new Error('useRole must be used within a RoleProvider');
  }

  return context;
};
